import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TProviderBrand, TProviderBrandResponse, adaptProviderBrandFromResponse } from '../../types';
import { BACKEND_ADMIN_PROVIDER_BRAND } from '../../backend-paths';


export const providerBrandReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_PROVIDER_BRAND}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_PROVIDER_BRAND}/${payload}`;

		return HttpService.get<TProviderBrandResponse>(path).then(result => {
			return adaptProviderBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerBrandReadSlice = createSlice({
	name: 'providerBrandReadSlice',
	initialState,
	reducers: {
		setProviderBrandRead(state, action: PayloadAction<TProviderBrand>) {
			state.item = action.payload;
		},

		clearProviderBrandRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerBrandReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerBrandReadGetApi.fulfilled.type]: (state, action: PayloadAction<TProviderBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerBrandReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderBrandReadSelector = () => useAppSelector(state => state[providerBrandReadSlice.name]);

export const { clearProviderBrandRead, setProviderBrandRead } = providerBrandReadSlice.actions;
